import React from 'react'

const Inpost = (props) => {
    return (
        <svg
            id="prefixInpost__Warstwa_1"
            x={0}
            y={0}
            viewBox="0 0 360 200"
            xmlSpace="preserve"
            {...props}
        >
            <style>
                {
                    ".prefixInpost__st7,.prefixInpost__st8{stroke-miterlimit:10}.prefixInpost__st7{fill:#d39437;stroke:#000;stroke-width:2.5;stroke-linejoin:round}.prefixInpost__st8{fill:none;stroke:#be9100;stroke-width:3}.prefixInpost__st10{fill:#3c3c3b}.prefixInpost__st11{fill:#fc0}.prefixInpost__st12{fill:#ccc}.prefixInpost__st13{fill:#222}.prefixInpost__st14{fill:#e6e6e6}"
                }
            </style>
            <path
                d="M360 152v.9c0 3.3-2.6 5.9-5.8 5.9H5.8c-3.2 0-5.8-2.6-5.8-5.9v-.9c0-3.3 2.6-5.9 5.8-5.9h35.5v-33.5h69.1v33.5h162.2v-28.9h63.1v28.9h18.6c3.1 0 5.7 2.7 5.7 5.9z"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#393534"
            />
            <g
                stroke="#000"
                strokeWidth={8}
                strokeLinecap="round"
                strokeMiterlimit={10}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="#ffe0bd"
                    d="M278.2 68.5l-9.5 15.2"
                />
                <path fill="none" d="M278.2 83.7l-7.1-3.8" />
            </g>
            <path
                d="M273.4 29.6h-51.3c-3.7 0-6.7 3-6.7 6.7v40.6c0 3.7 3 6.7 6.7 6.7h51.3c3.7 0 6.7-3 6.7-6.7V36.3c0-3.7-3-6.7-6.7-6.7z"
                fill="none"
                stroke="#000"
                strokeMiterlimit={10}
            />
            <path
                d="M355.4 103.4l-31.2-14.6c-1.9-.9-3.3-2.5-4-4.5l-24.5-76c-1-3.1-3.9-5.3-7.2-5.3h-278c-4.2 0-7.6 3.4-7.6 7.6v128c0 4.2 3.4 7.6 7.6 7.6h28.8c2.5 0 4.9-1.3 6.3-3.4 5.7-8.4 15.3-14 26.2-14 12.3 0 23 7 28.2 17.3h-.1l3.5 9.3c1.1 3 4 4.9 7.1 4.9h156.3c3.1 0 5.9-1.9 7.1-4.8l4.3-10.9h0c5.5-9.4 15.7-15.8 27.3-15.8 10.4 0 19.6 5 25.4 12.8 1.4 1.9 4.2 4.6 6.6 4.6H351c4.2 0 8.9-4.9 8.9-9.1v-26.8c-.1-2.9-1.8-5.6-4.5-6.9zm-75.3-26.5c0 3.7-3 6.7-6.7 6.7h-51.3c-3.7 0-6.7-3-6.7-6.7V36.3c0-3.7 3-6.7 6.7-6.7h51.3c3.7 0 6.7 3 6.7 6.7v40.6zm6.2 6.6V30h6.5c6.9 0 7.7 6.2 7.7 6.2l14.2 47.4h-28.4z"
                fill="#fff"
                stroke="#000"
                strokeMiterlimit={10}
            />
            <path
                d="M231.4 91.1v-3.5l-14.6.8s-1 .2-1 1 1.2.8 1.2.8l14.4.9z"
                stroke="#000"
                strokeWidth={0.5}
                strokeLinejoin="round"
                strokeMiterlimit={10}
            />
            <path
                d="M359.6 109s-3.1-1.2-3.1 1.9V129s3.1 3.9 3.1 1.5V109z"
                fill="#fff"
                stroke="#000"
                strokeWidth={2}
                strokeLinejoin="round"
                strokeMiterlimit={10}
            />
            <circle className="prefixInpost__st7" cx={353.6} cy={123.2} r={2.9} />
            <path
                className="prefixInpost__st8"
                d="M284 33.3v94.2h-3.9c-5.8 7-12.2 26.2-12.2 26.2h-57.1V32.1c0-3.5 2.8-6.3 6.3-6.3h59.4c4.1 0 7.5 3.3 7.5 7.5zM210.8 153.6h-99s-6.4-32.9-40.6-33.3-36.6 21.9-36.6 21.9"
            />
            <path className="prefixInpost__st8" d="M35.5 141.1H9V17.9s-.4-5.2-6.1-6.1" />
            <path
                d="M3.1 109s3.1-1.2 3.1 1.9V129s-3.1 3.9-3.1 1.5V109z"
                fill="#c4000d"
                stroke="#000"
                strokeWidth={0.75}
                strokeLinejoin="round"
                strokeMiterlimit={10}
            />
            <circle className="prefixInpost__st7" cx={9.2} cy={123.4} r={2.9} />
            <g>
                <path
                    className="prefixInpost__st10"
                    d="M106.9 87.3c0-.7-.6-1.2-1.5-1.2s-1.5.5-1.5 1.2.6 1.2 1.5 1.2 1.5-.5 1.5-1.2m-3.5 1.6c-.5-.4-.7-.9-.7-1.6 0-.7.2-1.2.7-1.6.5-.4 1.2-.6 2-.6s1.5.2 2 .6c.5.4.8.9.8 1.6 0 .7-.3 1.2-.8 1.6-.5.4-1.2.6-2 .6-.8-.1-1.5-.2-2-.6M113 85.2h1.3v4.1H113v-.6c-.3.5-.9.7-1.6.7-.7 0-1.1-.2-1.5-.5-.4-.4-.5-.8-.5-1.7v-2h1.3v2c0 .5.1.8.4 1 .2.1.4.2.7.2.6 0 1-.3 1.2-.7.1-.1.1-.3.1-.5v-2zM119 88.4v1h-1.6c-.9 0-1.2-.3-1.2-1.1v-2.1h-.8v-1h.8v-1.1h1.3v1.1h1.6v1h-1.6V88c0 .3.1.4.5.4h1zM126.6 87.3c0-.7-.6-1.2-1.5-1.2s-1.5.5-1.5 1.2.6 1.2 1.5 1.2 1.5-.5 1.5-1.2m-3.5 1.6c-.5-.4-.7-.9-.7-1.6 0-.7.2-1.2.7-1.6.5-.4 1.2-.6 2-.6s1.5.2 2 .6c.5.4.8.9.8 1.6 0 .7-.3 1.2-.8 1.6-.5.4-1.2.6-2 .6-.8-.1-1.5-.2-2-.6M131.9 84.7h-.8c-.3 0-.5.1-.5.3v.3h1.3v1h-1.3v3.2h-1.3v-3.2h-.7v-1h.7V85c0-.8.5-1.2 1.7-1.2h.9v.9zM138.8 88.4v1h-1.6c-.9 0-1.2-.3-1.2-1.1v-2.1h-.8v-1h.8v-1.1h1.3v1.1h1.6v1h-1.6V88c0 .3.1.4.5.4h1zM140.1 89.3v-5.6h1.3v2.1c.3-.4.9-.7 1.7-.7.6 0 1.1.2 1.5.5.4.4.6.8.6 1.7v2h-1.3v-2c0-.5-.1-.8-.4-.9-.2-.2-.5-.2-.8-.2-.6 0-1.1.3-1.3.7-.1.1-.1.3-.1.5v1.9h-1.2zM147.6 86.8h2.7c-.1-.5-.6-.8-1.3-.8-.8 0-1.3.3-1.4.8m-.6 2.1c-.5-.4-.7-.9-.7-1.6 0-.6.3-1.2.8-1.6.5-.4 1.2-.6 2-.6s1.4.2 1.9.5c.5.4.7.8.7 1.4v.5h-4.1c.1.6.7.9 1.6.9.7 0 1.3-.2 1.7-.5l.7.7c-.5.5-1.4.8-2.5.8-1 0-1.6-.1-2.1-.5M159.5 87.3c0-.7-.6-1.2-1.4-1.2-.9 0-1.5.5-1.5 1.2s.6 1.2 1.5 1.2 1.4-.5 1.4-1.2m-4.2 2v-5.6h1.3v2c.4-.4 1-.6 1.7-.6s1.3.2 1.8.6c.5.4.7.9.7 1.6 0 .6-.2 1.2-.7 1.6-.5.4-1.1.6-1.8.6s-1.3-.2-1.8-.6v.5h-1.2zM166 87.3c0-.7-.6-1.2-1.5-1.2s-1.5.5-1.5 1.2.6 1.2 1.5 1.2 1.5-.5 1.5-1.2m-3.5 1.6c-.5-.4-.7-.9-.7-1.6 0-.7.2-1.2.7-1.6.5-.4 1.2-.6 2-.6s1.5.2 2 .6c.5.4.8.9.8 1.6 0 .7-.3 1.2-.8 1.6-.5.4-1.2.6-2 .6-.8-.1-1.5-.2-2-.6M173.5 89.3h-1.7l-1.3-1.3-1.2 1.3h-1.6l2.1-2-2-2.1h1.6l1.2 1.3 1.2-1.3h1.6l-2 2zM115.9 78.4h-3.4v-9.3c0-2-.9-3-2.6-3.1-1-.1-2.7.2-3.8.4v12h-3.4V64.1s4.1-.9 7.9-.9c1.6 0 2.9.5 3.9 1.5 1 .9 1.5 2.2 1.5 3.8v9.9zM173.4 78.5c-.6.1-1.1.2-1.7.2-1.9 0-3.2-.4-3.8-1.2-.5-.6-.7-1.8-.7-3.6V59h3.4v4.2h3v2.6h-3v7.9c0 .8.1 1.4.3 1.7.3.3.8.5 1.7.5.2 0 .5 0 .9-.1v2.7z"
                />
                <path
                    className="prefixInpost__st11"
                    d="M68 68.7s-4 1.5-8.9 1.5-8.9-1.5-8.9-1.5 4-1.5 8.9-1.5c5 0 8.9 1.5 8.9 1.5M80.4 47.2s-3.5-2.3-6.3-6.1-3.7-7.7-3.7-7.7 3.5 2.3 6.3 6c2.8 3.9 3.7 7.8 3.7 7.8M71.3 56.5s-4.3-.5-8.6-2.6-7.1-5.2-7.1-5.2 4.3.5 8.6 2.6c4.4 2.1 7.1 5.2 7.1 5.2M80 75.7c2.5 0 5.6-1.9 5.6-1.9s-7.1-2-6.6-8c1.4-9.9 9.8-17.6 20.4-18.9-1.1-.1-2.3-.2-3.4-.2-13.1.1-23.6 9.9-23.5 22.1-.1 12.1 10.5 21.9 23.6 21.8 1.1 0 2.2-.1 3.2-.2-9.3-1.1-16.8-7.2-19.5-15.2M80.4 90.1s-3.5 2.3-6.3 6.1-3.7 7.7-3.7 7.7 3.5-2.3 6.3-6.1 3.7-7.7 3.7-7.7M71.3 80.8s-4.3.5-8.6 2.6-7.1 5.2-7.1 5.2 4.3-.5 8.6-2.6c4.4-2.1 7.1-5.2 7.1-5.2"
                />
                <path
                    className="prefixInpost__st10"
                    d="M95.8 58.9h3.5v19.4h-3.5zM134.2 65.6c0 2-.7 3.6-1.9 4.8-1.3 1.2-3.1 1.8-5.3 1.8h-4.2v6.1h-3.5V58.9h7.4c2.4 0 4.3.6 5.5 1.8 1.3 1.2 2 2.8 2 4.9m-3.5 0c0-2.4-1.2-3.5-3.6-3.5h-4.3v7h4.2c1.2 0 2.1-.3 2.7-.9.6-.7 1-1.5 1-2.6M150.3 70.7c0 2.3-.7 4.2-2.1 5.6-1.4 1.4-3.2 2.1-5.4 2.1s-4-.7-5.4-2.1c-1.4-1.4-2.1-3.3-2.1-5.6s.7-4.2 2.1-5.6c1.4-1.4 3.2-2.1 5.4-2.1s4 .7 5.4 2.1c1.4 1.4 2.1 3.2 2.1 5.6m-3.5 0c0-1.5-.4-2.6-1.1-3.5-.7-.9-1.7-1.3-2.9-1.3s-2.1.4-2.9 1.3c-.7.9-1.1 2-1.1 3.5s.4 2.6 1.1 3.5c.7.9 1.7 1.3 2.9 1.3s2.1-.4 2.9-1.3c.7-.9 1.1-2.1 1.1-3.5M165.1 73.4c0 1.5-.6 2.7-1.8 3.6-1.2.9-2.8 1.4-4.8 1.4-3.1 0-5.5-.9-7.1-2.6l2.6-2.1c1.3 1.2 2.8 1.8 4.5 1.8 1 0 1.7-.2 2.3-.5.6-.4.8-.8.8-1.3 0-.6-.3-1-1-1.3-.4-.1-1.4-.3-3-.6-2-.3-3.3-.7-4.2-1.2-1-.7-1.5-1.6-1.5-3 0-1.3.6-2.4 1.8-3.3 1.2-.9 2.8-1.3 4.7-1.3 2.4 0 4.4.7 6.1 2.2l-2 2c-1.2-1-2.6-1.5-4.2-1.5-2 0-3 .5-3 1.6 0 .6.5 1 1.4 1.3 1.3.2 2.6.4 3.8.6 3.1.5 4.6 1.9 4.6 4.2"
                />
            </g>
            <g>
                <path d="M276.3 160.7c0 15.9 12.9 28.9 28.9 28.9 15.9 0 28.9-12.9 28.9-28.9h-57.8z" />
                <path
                    className="prefixInpost__st12"
                    d="M326.3 160.7c0 11.7-9.5 21.2-21.2 21.2s-21.2-9.5-21.2-21.2h42.4z"
                />
                <path d="M313.2 160.7c0 4.5-3.6 8.1-8.1 8.1s-8.1-3.6-8.1-8.1h16.2z" />
            </g>
            <g>
                <path
                    className="prefixInpost__st13"
                    d="M334 160.7h-7.7c0-11.7-9.5-21.2-21.2-21.2S284 149 284 160.7h-7.7c0-15.9 12.9-28.9 28.9-28.9 15.9.1 28.8 13 28.8 28.9z"
                />
                <path
                    className="prefixInpost__st14"
                    d="M326.3 160.7h-13.1c0-4.5-3.6-8.1-8.1-8.1s-8.1 3.6-8.1 8.1h-13c0-11.7 9.5-21.2 21.2-21.2s21.1 9.5 21.1 21.2z"
                />
                <path
                    className="prefixInpost__st13"
                    d="M313.2 160.7H297c0-4.5 3.6-8.1 8.1-8.1 4.5.1 8.1 3.7 8.1 8.1z"
                />
            </g>
            <g>
                <path d="M42.2 160.7c0 15.9 12.9 28.9 28.9 28.9s28.9-12.9 28.9-28.9H42.2z" />
                <path
                    className="prefixInpost__st12"
                    d="M92.2 160.7c0 11.7-9.5 21.2-21.2 21.2s-21.2-9.5-21.2-21.2h42.4z"
                />
                <path d="M79.1 160.7c0 4.5-3.6 8.1-8.1 8.1s-8.1-3.6-8.1-8.1h16.2z" />
            </g>
            <g>
                <path
                    className="prefixInpost__st13"
                    d="M99.9 160.7h-7.7c0-11.7-9.5-21.2-21.2-21.2s-21.2 9.5-21.2 21.2h-7.7c0-15.9 12.9-28.9 28.9-28.9s28.9 13 28.9 28.9z"
                />
                <path
                    className="prefixInpost__st14"
                    d="M92.2 160.7H79.1c0-4.5-3.6-8.1-8.1-8.1s-8.1 3.6-8.1 8.1h-13c0-11.7 9.5-21.2 21.2-21.2s21.1 9.5 21.1 21.2z"
                />
                <path
                    className="prefixInpost__st13"
                    d="M79.1 160.7H63c0-4.5 3.6-8.1 8.1-8.1s8 3.7 8 8.1z"
                />
            </g>
        </svg>
    )
}

export default Inpost
